module.exports = "mutation UpdateProviderComment($comment:UpdateProviderCommentInput!){updateComment:updateProviderComment(comment:$comment){success}}"